import React from 'react';
import { Card, Accordion } from 'react-bootstrap';
export default function Step3APleated({
 ContextAwareToggle,
 t,
 step2B,
 step2C,
 accordionActiveKey,
 requiredStep,
 stepSelectedLabel,
 modalHandleShow,
 setSheerHeaderStyleTemp2,
 setStep2C,
 setDeps,
 setCart,
 selectChanged,
 setSheersModelId2,
 inputs,
 step8,
 NextStep,
}) {
 
  return (
   <Card className={step2B !== "" && step2B !== "None" ? "" : "noDisplay"}>
   <Card.Header
     className={
       step2C !== "" &&
       (!accordionActiveKey.startsWith("2") ||
         accordionActiveKey === "2A" ||
         accordionActiveKey === "2")
         ? "hidden"
         : ""
     }
   >
     <ContextAwareToggle
       eventKey="2C"
       stepNum={t("3A")}
       stepTitle={t("grommet_step2A_sheer")}
       stepRef="2C"
       type="1"
       required={requiredStep["2C"]}
       stepSelected={
         stepSelectedLabel["2C"] === undefined ? "" : stepSelectedLabel["2C"]
       }
     />
   </Card.Header>
   <Accordion.Collapse eventKey="2C">
     <Card.Body>
       <div className="card_body card_body_radio card_body_radio_camera card_body_radio_small_img">
         <div className="box33 radio_style">
           <img
             src={require("../../Images/drapery/european/pleated2a.svg").default}
             className="img-fluid"
             alt=""
           />
           <input
             className="radio"
             type="radio"
             text={t("double european pleat")}
             value="1"
             name="step2C"
             ref-num="2C"
             id="2C1"
             checked={step2C === "Double European Pleat"}
             onChange={(e) => {
               if (
                 (step2C === "Inverted Box Pleat" ||
                   step2C === "Pencil Pleat") &&
                 step8 === "I Want To Customize Hardware Per Curtain"
               ) {
                 modalHandleShow("SheerHeaderStyleWarning2");
                 setSheerHeaderStyleTemp2({
                   stepValue: "Double European Pleat",
                   id: "0036",
                   cartValue: "Double European Pleat",
                   event: e,
                 });
               } else {
                 setStep2C("Double European Pleat");
                 setDeps("", "2C");
                 setCart(
                   "PrivacyLayerHeaderStyle",
                   "Double European Pleat",
                   "",
                   "PrivacyLayerHeaderStyleID",
                   ["0036"]
                 );
                 selectChanged(e);
                 setSheersModelId2("0036");
               }
             }}
             ref={(ref) => (inputs.current["2C1"] = ref)}
           />
           <label htmlFor="2C1">{t("HeaderStyle5")}</label>
         </div>
         <div className="box33 radio_style">
           <img
             src={require("../../Images/drapery/grommet/Inverted_sketch.svg").default}
             className="img-fluid"
             alt=""
           />
           <input
             className="radio"
             type="radio"
             text={t("Inverted Box Pleat")}
             value="2"
             name="step2C"
             ref-num="2C"
             id="2C2"
             checked={step2C === "Inverted Box Pleat"}
             onChange={(e) => {
               if (
                 (step2C === "Pleated" || step2C === "Rod Pocket") &&
                 step8 === "I Want To Customize Hardware Per Curtain"
               ) {
                 modalHandleShow("SheerHeaderStyleWarning2");
                 setSheerHeaderStyleTemp2({
                   stepValue: "Inverted Box Pleat",
                   id: "0036",
                   cartValue: "Inverted Box Pleat",
                   event: e,
                 });
               } else {
                 setStep2C("Inverted Box Pleat");
                 setDeps("", "2C");
                 setCart(
                   "PrivacyLayerHeaderStyle",
                   "Inverted Box Pleat",
                   "",
                   "PrivacyLayerHeaderStyleID",
                   ["0036"]
                 );
                 selectChanged(e);
                 setSheersModelId2("0036");
               }
             }}
             ref={(ref) => (inputs.current["2C2"] = ref)}
           />
           <label htmlFor="2C2">{t("HeaderStyle2")}</label>
         </div>
         <div className="box33 radio_style">
           <img
             src={require("../../Images/drapery/grommet/pencilPleat.svg").default}
             className="img-fluid"
             alt=""
           />
           <input
             className="radio"
             type="radio"
             text={t("Pencil Pleat")}
             value="3"
             name="step2C"
             ref-num="2C"
             id="2C3"
             checked={step2C === "Pencil Pleat"}
             onChange={(e) => {
               if (
                 (step2C === "Pleated" || step2C === "Rod Pocket") &&
                 step8 === "I Want To Customize Hardware Per Curtain"
               ) {
                 modalHandleShow("SheerHeaderStyleWarning2");
                 setSheerHeaderStyleTemp2({
                   stepValue: "Pencil Pleat",
                   id: "0002",
                   cartValue: "Pencil Pleat",
                   event: e,
                 });
               } else {
                 setStep2C("Pencil Pleat");
                 setDeps("", "2C");
                 setCart(
                   "PrivacyLayerHeaderStyle",
                   "Pencil Pleat",
                   "",
                   "PrivacyLayerHeaderStyleID",
                   ["0002"]
                 );
                 selectChanged(e);
                 setSheersModelId2("0002");
               }
             }}
             ref={(ref) => (inputs.current["2C3"] = ref)}
           />
           <label htmlFor="2C3">{t("HeaderStyle3")}</label>
         </div>

         <NextStep currentStep={step2C !== "" ? "2B" : "2C"} eventKey="3A0">
           {t("NEXT STEP")}
         </NextStep>
       </div>
     </Card.Body>
   </Accordion.Collapse>
 </Card>
  )
}
